import PropTypes from 'prop-types';

import Tag from '#globalComponents/Tag/Tag';
import { formatDate } from '#lib/dateUtils';

import { collectionDateShape, collectionStatShape, collectionTagShape } from './collectionItemShape';

export const CollectionItemStats = ({ stats = [] }) =>
	stats.length > 0 && (
		<p className="mt-0.5 flex flex-wrap gap-x-2 text-xs text-primary-500">
			{stats.map(({ value, label }) => (
				<span key={label} className="truncate">
					{value !== undefined && <span className="font-bold">{value} </span>}
					{label}
				</span>
			))}
		</p>
	);

CollectionItemStats.propTypes = { stats: PropTypes.arrayOf(collectionStatShape) };

export const CollectionItemTags = ({ tags = [] }) => (
	<div className="flex min-w-0 flex-wrap items-center gap-1.5">
		{tags.map((tag) => (
			<Tag key={`${tag.prefix}-${tag.label}`} {...tag} />
		))}
	</div>
);

CollectionItemTags.propTypes = { tags: PropTypes.arrayOf(collectionTagShape) };

export const CollectionItemDate = ({ date, className = '' }) => (
	<div className={className}>
		{date && (
			<>
				<p className="text-xs text-text">{date.label}</p>
				<p className="text-md text-bgBase-800">{formatDate(date.value)}</p>
			</>
		)}
	</div>
);

CollectionItemDate.propTypes = {
	date: collectionDateShape,
	className: PropTypes.string,
};
